"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var buffer_1 = require("buffer");

var CotterJwtToken = /*#__PURE__*/function () {
  function CotterJwtToken(token) {
    _classCallCheck(this, CotterJwtToken);

    this.token = token;
    this.payload = this.decodePayload();
  }

  _createClass(CotterJwtToken, [{
    key: "decodePayload",
    value: function decodePayload() {
      var payload = this.token.split(".")[1];

      try {
        var obj = JSON.parse(buffer_1.Buffer.from(payload, "base64").toString("utf8"));
        return obj;
      } catch (err) {
        return {};
      }
    }
  }, {
    key: "getExpiration",
    value: function getExpiration() {
      var payload = this.payload;
      return payload.exp;
    }
  }, {
    key: "getIssuedAt",
    value: function getIssuedAt() {
      var payload = this.payload;
      return payload.iat;
    }
  }, {
    key: "getAudience",
    value: function getAudience() {
      var payload = this.payload;
      return payload.aud;
    }
  }]);

  return CotterJwtToken;
}();

exports.default = CotterJwtToken;